import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Drawer } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import UpdateSequenceForm from '@Components/Settings/MyProfile/Sequence/UpdateSequenceForm';
import './style.scss';

class Sequence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      limit: 10,
      isUserReady: false,
      uomListColumns: [
        {
          title: 'DOCUMENT',
          render: (text, record) => (
            <Fragment>
              {record?.type?.replaceAll('_', ' ').toProperCase()}
            </Fragment>
          ),
        },
        {
          title: 'PREFIX',
          render: (text, record) => (
            <Fragment>
              {record?.prefix}
            </Fragment>
          ),
        },
        {
          title: 'CURRENT SEQUENCE',
          render: (text, record) => (
            <Fragment>
              {record?.sqn}
            </Fragment>
          ),
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => (
            <div style={{
              textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <div
                className="roundIconButton"
                onClick={() => this.setState({ sequenceData: record, showSequenceDrawer: true })}
              >
                <EditOutlined />
              </div>
            </div>
          ),
        },
      ],
      showNewUomModal: false,
      showUpdateUomModal: false,
      searchKeyword: '',
    };
  }

  getData() {
    const { poSequence } = this.props;
    const data = [];
    if (poSequence) {
      const sqnData = poSequence;
      data.push({
        type: 'INVENTORY_ADJUSTMENT', prefix: sqnData?.ia_doc_prefix, sqn: sqnData?.ia_doc_counter, prefixKey: 'ia_doc_prefix', sqnKey: 'ia_doc_counter',
      });
      data.push({
        type: 'STOCK_TRANSFER', prefix: sqnData?.st_doc_prefix, sqn: sqnData?.st_doc_counter, prefixKey: 'st_doc_prefix', sqnKey: 'st_doc_counter',
      });
      data.push({
        type: 'DELIVERY_CHALLAN', prefix: sqnData?.dc_doc_prefix, sqn: sqnData?.dc_doc_counter, prefixKey: 'dc_doc_prefix', sqnKey: 'dc_doc_counter',
      });
      data.push({
        type: 'PURCHASE_REQUEST', prefix: sqnData?.pr_doc_prefix, sqn: sqnData?.pr_doc_counter, prefixKey: 'pr_doc_prefix', sqnKey: 'pr_doc_counter',
      });
      data.push({
        type: 'PURCHASE_ORDER', prefix: sqnData?.po_doc_prefix, sqn: sqnData?.po_doc_counter, prefixKey: 'po_doc_prefix', sqnKey: 'po_doc_counter',
      });
      data.push({
        type: 'GOODS_RECEIVING_NOTE', prefix: sqnData?.grn_doc_prefix, sqn: sqnData?.grn_doc_counter, prefixKey: 'grn_doc_prefix', sqnKey: 'grn_doc_counter',
      });
      data.push({
        type: 'DEBIT_NOTE', prefix: sqnData?.dn_doc_prefix, sqn: sqnData?.dn_doc_counter, prefixKey: 'dn_doc_prefix', sqnKey: 'dn_doc_counter',
      });
      data.push({
        type: 'SALES_ESTIMATE', prefix: sqnData?.se_doc_prefix, sqn: sqnData?.se_doc_counter, prefixKey: 'se_doc_prefix', sqnKey: 'se_doc_counter',
      });
      data.push({
        type: 'SALES_ORDER', prefix: sqnData?.so_doc_prefix, sqn: sqnData?.so_doc_counter, prefixKey: 'so_doc_prefix', sqnKey: 'so_doc_counter',
      });
      data.push({
        type: 'ANNUAL_MAINTENANCE_CONTRACT', prefix: sqnData?.amc_doc_prefix, sqn: sqnData?.amc_doc_counter, prefixKey: 'amc_doc_prefix', sqnKey: 'amc_doc_counter',
      });
      data.push({
        type: 'PACKING_SLIP', prefix: sqnData?.ps_doc_prefix, sqn: sqnData?.ps_doc_counter, prefixKey: 'ps_doc_prefix', sqnKey: 'ps_doc_counter',
      });
      data.push({
        type: 'INVOICE', prefix: sqnData?.inv_doc_prefix, sqn: sqnData?.inv_doc_counter, prefixKey: 'inv_doc_prefix', sqnKey: 'inv_doc_counter',
      });
      data.push({
        type: 'CREDIT_NOTE', prefix: sqnData?.cn_doc_prefix, sqn: sqnData?.cn_doc_counter, prefixKey: 'cn_doc_prefix', sqnKey: 'cn_doc_counter',
      });
      data.push({
        type: 'RETURN_SLIP', prefix: sqnData?.rs_doc_prefix, sqn: sqnData?.rs_doc_counter, prefixKey: 'rs_doc_prefix', sqnKey: 'rs_doc_counter',
      });
      data.push({
        type: 'MANUFACTURING_ORDER', prefix: sqnData?.mo_doc_prefix, sqn: sqnData?.mo_doc_counter, prefixKey: 'mo_doc_prefix', sqnKey: 'mo_doc_counter',
      });
    }
    return data;
  }

  static getDerivedStateFromProps(props, state) {
    const { getPoSequence, user } = props;
    const { isUserReady } = state;
    if (user && !isUserReady) {
      getPoSequence(user?.tenant_info?.tenant_id);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  render() {
    const {
      getPoSequenceLoading, user, getPoSequence,
    } = this.props;
    const {
      uomListColumns, showSequenceDrawer, sequenceData,
    } = this.state;
    return (
      <Fragment>
        <div className="sqn__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-18 width-100-in-mobile">
              <div className="sqn__table__wrapper">
                <div className="sqn__table__data show-table-header-in-mobile">
                  <Table
                    loading={getPoSequenceLoading}
                    showHeader
                    size="small"
                    scroll="scroll"
                    columns={uomListColumns}
                    dataSource={this.getData()}
                    pagination={false}
                    bordered
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Drawer
          open={showSequenceDrawer}
          width="480px"
          mask
          onClose={() => this.setState({ showSequenceDrawer: false })}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '425px' }}>
              <H3Text text={`Update Document Number for ${sequenceData?.type?.replaceAll('_', ' ').toProperCase()}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showSequenceDrawer: false })} />
            </div>
          </div>
          <div className="create-po__new-vendor-wrapper">
            <UpdateSequenceForm
              sequenceData={sequenceData}
              callback={() => {
                this.setState({ showSequenceDrawer: false });
                getPoSequence(user?.tenant_info?.tenant_id);
              }}
            />
          </div>
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers,
}) => ({
  user: UserReducers.user,
  getPoSequenceLoading: PurchaseOrderReducers.getPoSequenceLoading,
  poSequence: PurchaseOrderReducers.poSequence,
});

const mapDispatchToProps = (dispatch) => ({
  getPoSequence: (tenantId) => dispatch(PurchaseOrderActions.getPoSequence(tenantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sequence));
